<template>
  <div>
    <v-dialog
      v-model="is_show"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Invita nel team</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="formInvite"
            @submit.prevent="inviteProfessional"
          >
            <v-row class="ma-0">
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="formInvite.email"
                  label="Email"
                  type="email"
                  outlined
                  required
                  dense
                  :rules="[formRules.required,formRules.emailRules]"
                  :disabled="loadingBtn"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
              >
                <v-select
                  v-model="formInvite.company_role"
                  label="Ruolo"
                  outlined
                  required
                  dense
                  :items="[{'text':'Membro','value':'member'},{'text':'Amministratore','value':'owner'}]"
                  :rules="[formRules.required]"
                  :disabled="loadingBtn"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                class="text-right"
              >
                <v-btn
                  class="ma-2"
                  :disabled="loadingBtn"
                  @click="closeModal"
                >
                  Chiudi
                </v-btn>
                <v-btn
                  color="primary"
                  class="ma-2"
                  :loading="loadingBtn"
                  :disabled="loadingBtn"
                  @click.prevent="inviteProfessional"
                >
                  Invita
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EditProcedure',
  components: {

  },
  props: {
    is_show: {
      type: Boolean,
      default: false,
    },
    companyData: Object,
  },
  data() {
    return {
      formInvite: {},
      loadingBtn: false,
    }
  },
  computed: {
    ...mapGetters(['formRules', 'procedureList']),
  },
  methods: {
    async inviteProfessional() {
      if (this.$refs.formInvite.validate()) {
        try {
          this.loadingBtn = true
          await this.$api.inviteProfessionalIntoCompany(this.companyData.id, this.formInvite)
          this.$store.dispatch('set_alert', { msg: 'Invito spedito con successo', type: 'success' })
          this.closeModal()
          this.loadingBtn = false
        } catch (e) {
          this.loadingBtn = false
          this.$store.dispatch('set_alert', { msg: 'error', type: 'error' })
        }
      }
    },
    closeModal() {
      this.$refs.formInvite.reset()
      this.$emit('close')
      this.loading = false
    },
  },
}
</script>

<style scoped>

</style>
